<ion-item lines="none" class="input-item" [class.focused]="isFocused">
  <!-- Start Icon -->
  <ion-icon
    *ngIf="icon && iconPosition === 'start'"
    [name]="icon"
    slot="start"
    class="input-icon input-icon-start"
    (click)="onIconClick()">
  </ion-icon>

  <!-- Input Field -->
  <ion-input
    [type]="type"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    [readonly]="readonly"
    [maxlength]="maxlength"
    [minlength]="minlength"
    [pattern]="pattern"
    [autocomplete]="autocomplete"
    [inputmode]="inputmode"
    class="custom-input"
    (ionInput)="onInputChange($event)"
    (ionFocus)="onFocus($event)"
    (ionBlur)="onBlur($event)">
  </ion-input>

  <!-- End Icon -->
  <ion-icon
    *ngIf="icon && iconPosition === 'end'"
    [name]="icon"
    slot="end"
    class="input-icon input-icon-end"
    (click)="onIconClick()">
  </ion-icon>
</ion-item>